module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "storages-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-storageprices",
      "to": {
        name: 'StoragePrices'
      },
      "md-label": "Список"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-settings",
      "to": {
        name: 'StoragePricesSettings'
      },
      "md-label": "Настройки"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a3f04f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/storage/StoragesMenu.vue
// module id = 1189
// module chunks = 0